<script setup lang="ts">
import { computed } from 'vue'

import type { SubParticipant } from '@collector/sportsapi-types'

type Props = {
  player: SubParticipant
  highlightMissingId?: boolean
  prefix?: string
}

const props = defineProps<Props>()

const detailsText = computed(() => {
  const birthdayText = props.player.details?.birthdate || 'Birthdate is not set'
  const nameText = props.player.name || 'Name is not set'
  return `${birthdayText}\n${nameText}`
})
</script>

<template>
  <span
    class="w-full text-sm"
    :class="{ italic: !player.id && highlightMissingId }"
    :title="detailsText"
    data-testid="lineups-player-name"
  >
    {{ prefix }} {{ player.short_name }}
  </span>
</template>

<style scoped></style>
